"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
const styleOverrides = {
  root: {
    width: 42,
    height: 26,
    padding: 0,
    [`&.${_material.switchClasses.sizeSmall}`]: {
      width: 30,
      height: 20
    },
    [`&.${_material.switchClasses.sizeSmall} .${_material.switchClasses.switchBase}`]: {
      padding: 0,
      [`&.${_material.switchClasses.checked}`]: {
        transform: 'translateX(10px)'
      }
    }
  },
  switchBase: ({
    theme
  }) => ({
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    [`&.${_material.switchClasses.checked}`]: {
      transform: 'translateX(16px)',
      color: theme.palette.common.white,
      [`& + .${_material.switchClasses.track}`]: {
        backgroundColor: theme.palette.default.dark,
        opacity: 1,
        border: 0
      }
    },
    [`&.Mui-focusVisible .${_material.switchClasses.thumb}`]: {
      color: theme.palette.default.dark,
      border: `6px solid ${theme.palette.common.white}`
    },
    [`&.${_material.switchClasses.disabled} .${_material.switchClasses.thumb}`]: {
      color: theme.palette.grey[100],
      opacity: 1
    },
    [`&.${_material.switchClasses.disabled} + .${_material.switchClasses.track}`]: {
      backgroundColor: theme.palette.grey[200],
      opacity: 1
    }
  }),
  thumb: {
    boxSizing: 'border-box',
    width: 22,
    height: 22
  },
  track: ({
    theme
  }) => ({
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.grey[500],
    opacity: 1
  })
};
const defaultProps = {
  focusVisibleClassName: '.Mui-focusVisible',
  disableRipple: true
};
var _default = exports.default = {
  defaultProps,
  styleOverrides
};
